module.exports = __webpack_public_path__ + "images/emoji/video_game.652227ee6f7661b0f58c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/video_game.png
// module id = wjmi
// module chunks = 14